export const PROGRESS_SIZES = {
  SIZE_10: `--progress-size-10`,
  SIZE_20: `--progress-size-20`,
  SIZE_30: `--progress-size-30`,
  SIZE_40: `--progress-size-40`,
} as const
export type PROGRESS_SIZES =
  (typeof PROGRESS_SIZES)[keyof typeof PROGRESS_SIZES]
